import { useNavigate } from 'react-router-dom';
import { alertApiRef, useApi } from '@backstage/core-plugin-api';
import { scaffolderApiRef } from '@backstage/plugin-scaffolder-react';
import { ConfigChange } from '@internal/backstage-plugin-release-common';

/** The template that opens the gitops pull requests. The screen edits and
 * reviews; the template does the work, and its task history is the audit
 * record, alongside the pull requests themselves. */
const CONFIG_SET_TEMPLATE = 'template:default/config-set';

export interface ConfigurePlan {
  service: string;
  changes: ConfigChange[];
  dryRun: boolean;
}

/** Starts the configuration task from a reviewed plan and follows it. */
export function useSetValues(onStarted?: () => void) {
  const scaffolderApi = useApi(scaffolderApiRef);
  const alertApi = useApi(alertApiRef);
  const navigate = useNavigate();

  return async (plan: ConfigurePlan) => {
    try {
      const { taskId } = await scaffolderApi.scaffold({
        templateRef: CONFIG_SET_TEMPLATE,
        values: {
          service: plan.service,
          changes: plan.changes,
          dryRun: plan.dryRun,
        },
      });
      onStarted?.();
      navigate(`/create/tasks/${taskId}`);
    } catch (error) {
      alertApi.post({
        message: `Could not start the change: ${(error as Error).message}`,
        severity: 'error',
      });
    }
  };
}
